import { Button } from '@material-ui/core';
import { DocumentFileIcon, DownloadIconTwoTone, MicrophoneIcon } from '@room-match/shared-ui-components';
import React from 'react';
import { CustomTypography } from 'shared/elements/CustomTypography';
import { IMediumAttributes } from 'shared/interfaces/IMedium';
import { formatBytes } from 'shared/utils/room-shared';
import { useStyles } from './MediaContainer.styles';

interface Props {
  media: IMediumAttributes;
  mode?: 'lightModeOnly';
  style?: React.CSSProperties;
  isLarge?: boolean;
}

const MediaContainer: React.FC<Props> = ({ media, mode, style, isLarge = false }) => {
  const classes = useStyles({ mode: mode })();
  const handleClick = () => {
    return window.open(`${media.attachment}`, '_blank');
  };

  return (
    <Button
      className={classes.root}
      style={{ ...style, zoom: isLarge ? 1.5 : 1, marginBottom: isLarge ? 10 : 0 }}
      onClick={handleClick}
    >
      {media.medium.file_type.toLocaleLowerCase() === 'audio' ? <MicrophoneIcon /> : <DocumentFileIcon />}
      <CustomTypography
        fontSize={13}
        limitCharacters="long"
        style={{ marginLeft: 5 }}
        color={mode === 'lightModeOnly' ? 'lightModeOnly' : undefined}
      >
        {media.medium.file_name}
      </CustomTypography>
      <CustomTypography fontSize={13} limitCharacters="short">
        ({formatBytes(media.medium.file_size)})
      </CustomTypography>
      <DownloadIconTwoTone style={{ marginLeft: 10 }} />
    </Button>
  );
};

export default MediaContainer;
